import darkTheme from './dark';
import lightTheme from './light';

const promobit = {
  dark: darkTheme,
  light: lightTheme,
};

export default promobit;
